import { getAPIRequest } from 'infrastructure/api'
import { loadable } from 'jotai/utils'
import { atom } from 'infrastructure/state/jotai.wrapper'
import { atomWithRefresh } from 'infrastructure/state/atomWithRefresh'

type UserResponse = {
  analytics_id: string
  created_at: string
  email: string
  google_email?: string
  google_id?: unknown
  id: number
  image_url: string
  is_demo_user: boolean
  is_email_verified: boolean
  is_rostered: boolean
  is_verified: boolean
  last_activity_at: string
  last_login_at: string
  login_name?: unknown
  name: string
  platform_features: { id: number; name: string }[]
  roles: { luser_id: number; role: string }[]
  roles_list: string[]
  school_id: number
}

export const currentUserWithRefresh = atomWithRefresh(() => {
  return getAPIRequest<UserResponse>('/api2/user')
})

export const currentUserResponseAtom = loadable(
  atom(async (get) => {
    return get(currentUserWithRefresh)
  }),
)
